module.exports = __webpack_public_path__ + "images/mod-squad-dc489fdb8542bee00a0fece76aa311c7.png";